import Vue from 'vue'
import App from './App.vue'
Vue.prototype.GLOBAL = App;

// import axios from 'axios'
import VueAxios from 'vue-axios'

// axios updata 2019 11 28
import axios from "./axios.js"
Vue.prototype.$http = axios
// API Calls 2019 11 28
import "./http/requests"

// mock
import "./fake-db/index.js"

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax

Vue.use(Vuesax);
Vue.prototype.axios = axios;
Vue.use(VueAxios, axios);

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Vuexy Admin Filters
import './filters/filters'

// Tailwind
import '@/assets/css/main.css'

// VeeValidate
import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

// Vue Router
import router from './router'

//Uncaught (in promise) NavigationDuplicated {_name: "NavigationDuplicated", name: "NavigationDuplicated"}；
import Router from 'vue-router'
const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

//引入编辑器
import  VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(VueQuillEditor);

import  jq from 'jquery'

// import echarts from 'echarts'
// import china from 'echarts/map/json/china.json'
// Vue.prototype.$echarts = echarts


import Cookies from 'js-cookie'
/*区分关闭和刷新，关闭退出登录 start*/
window.onload = function(){
  if(!window.sessionStorage["tempFlag"]){
    Cookies.remove('uid')
    Cookies.remove('x-auth-token')
    router.push('/pages/login');   //不能省，强制跳到登陆页
  }else{
    window.sessionStorage.removeItem("tempFlag");
  }
}
window.onunload = function (){
  window.sessionStorage["tempFlag"] = true;
}
window.onbeforeunload = function (){
  window.sessionStorage["tempFlag"] = true;
}

// Vuex Store
import store from './store/store'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

//数字三位数逗号隔开
Vue.filter('NumFormat', function(value) {
  if(!value) return '0';
  /*原来用的是Number(value).toFixed(0)，这样取整时有问题，例如0.51取整之后为1，感谢Nils指正*/
  /*后来改成了 Number(value)|0,但是输入超过十一位就为负数了，具体见评论 */
  var intPart = Number(value) - Number(value)%1; //获取整数部分（这里是windy93的方法）
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
  var floatPart = ""; //预定义小数部分
  var value2Array = value.toString().split(".");
  //=2表示数据有小数位
  if(value2Array.length === 2) {
    floatPart = value2Array[1].toString(); //拿到小数部分
    if(floatPart.length === 1) { //补0,实际上用不着
      return intPartFormat + "." + floatPart + '0';
    } else {
      return intPartFormat + "." + floatPart;
    }
  } else {
    return intPartFormat + floatPart;
  }
});


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import i18n from './i18n'

// 添加请求拦截器，在请求头中加token
axios.interceptors.request.use(
  config => {
    if (localStorage.getItem('token')) {
      config.headers['Authorization'] ="Bearer"+" " +localStorage.getItem('token');
    }
    // if (localStorage.getItem('uid')) {
    //   config.headers['uid'] = localStorage.getItem('uid');
    // }
    return config;
  },
  error => {
    return Promise.reject(error);
  });
axios.interceptors.response.use(
  response => {
    // 未登录，返回登录页
    if (response.data.error === "401") {
      router.push('/pages/login');
    }
    return response
  },
  error => {
    if(error.response){
      if(error.response.status === 401){
        router.push('/pages/login');
      }
    }
    return Promise.reject(error)
  }
)

// Feather font icon
require('./assets/css/iconfont.css')

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
